/** XHR, not fetch: only XHR exposes upload progress. */
export const putWithProgress = (
    url: string,
    file: File,
    contentType: string,
    onProgress: (pct: number) => void,
): Promise<void> =>
    new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('PUT', url);
        xhr.setRequestHeader('Content-Type', contentType);
        xhr.upload.onprogress = (e) => {
            if (e.lengthComputable) onProgress(Math.round((e.loaded / e.total) * 100));
        };
        xhr.onload = () =>
            xhr.status >= 200 && xhr.status < 300 ? resolve() : reject(new Error(`Upload failed (HTTP ${xhr.status})`));
        xhr.onerror = () => reject(new Error('Upload failed (network or CORS error)'));
        xhr.send(file);
    });
